<template>
  <div>
    <video
      id="myVideo"
      class="video-js vjs-default-skin"
      playsinline
      autoplay
    />
    <b-row style="margin-top: 15px">
      <b-col>
        <b-button
          v-for="(aButton, i) in testRecordButtons"
          pill
          style="margin-left: 5px;"
          variant="primary"
          @click="handleRecord(aButton.type, aButton.recordLength)"
          :key="`tr-${i}`"
        >
          Record {{ aButton.type }}
        </b-button>
      </b-col>
    </b-row>

    <p>
      {{ trigger ? `Trigger:${trigger}` : "" }}
    </p>
  </div>
</template>

<script>
/* eslint-disable */
//https://collab-project.github.io/videojs-record/#/frameworks/vue
import 'video.js/dist/video-js.css';
import 'videojs-record/dist/css/videojs.record.css';
import videojs from 'video.js';
import 'webrtc-adapter';
import RecordRTC from 'recordrtc';

// the following imports are only needed when you're recording
// audio-only using the videojs-wavesurfer plugin
/*
import WaveSurfer from 'wavesurfer.js';
import MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
WaveSurfer.microphone = MicrophonePlugin;

// register videojs-wavesurfer plugin
import videojs_wavesurfer_css from 'videojs-wavesurfer/dist/css/videojs.wavesurfer.css';
import Wavesurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer.js';
*/

import firebase from "firebase";
import Record from 'videojs-record/dist/videojs.record.js';
//import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

export default {
  name: "Display_VideoCam",
  components: {},
  created(){

  },
  mounted(){
    this.init();
  },
  props: {
    recordLength:{
      type: Number,
      required: false,
      default: 5
    },
    output: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input(){
      return ""
    }
  },
  methods: {
    init() {
      /* eslint-disable no-console */
      this.player = videojs('#myVideo', this.options, () => {
        // print version information at startup
        var msg = 'Using video.js ' + videojs.VERSION +
            ' with videojs-record ' + videojs.getPluginVersion('record') +
            ' and recordrtc ' + RecordRTC.version;
        videojs.log(msg);
      });

      // device is ready
      this.player.on('deviceReady', () => {
        console.log('device is ready!');
        this.setMotionCaptureStream();
      });

      // user clicked the record button and started recording
      this.player.on('startRecord', () => {
        debugger;
        console.log('started recording!');
      });

      // user completed recording and stream is available
      this.player.on('finishRecord', () => {
        // the blob object contains the recorded data that
        // can be downloaded by the user, stored on server etc.
        debugger;
        console.log('finished recording: ', this.player.recordedData);

        this.player.record().saveAs({'video': 'my-video-file-name.webm'});
      });

      this.player.on('finishConvert', function() {
        debugger;
        // the convertedData object contains the recorded data that
        // can be downloaded by the user, stored on server etc.
        console.log('finished converting: ', this.player.convertedData);
        this.handleSaveRecording(this.player.convertedData);
    });
      

      // error handling
      this.player.on('error', (element, error) => {
        console.warn(error);
      });

      this.player.on('deviceError', () => {
        console.error('device error:', this.player.deviceErrorCode);
      });

      this.setUpVoiceControls();
    },
    setUpVoiceControls (){    
      if (annyang) {
        // Let's define a command.
        var commands = {
          'hello': () =>{
            //alert('Hello world!');
            //this.handleRecord();
          },
          'glance': () => {
            debugger
            this.handleRecord('Word-Glance');
          },
          'medication': () => {
            debugger
            this.handleRecord('Word-Medication');
          },
          'bath': () => {
            debugger
            this.handleRecord('Word-Bath');
          }
        };

        // Add our commands to annyang
        annyang.addCommands(commands);

        // Start listening.
        annyang.start();
      }
    },
    setMotionCaptureStream() {
      console.log('setMotionCaptureStream');
     // let video = document.getElementById('myVideo');
     // let player = this.player;

      //video.srcObject = stream;

      ///Context
      let canvas = document.createElement('canvas');
      canvas.width = 640;
      canvas.height = 480;
      this.motionContext = canvas.getContext('2d');
      setInterval(this.motionCaptureFrames(), 100);
    },
    motionCaptureFrames() {
      console.log('capture frame');
      const video = document.getElementById('myVideo');
      this.motionContext.drawImage(video, 0, 0, 640, 480);
    },
    handleRecord(trigger, recordLength=10) {
      debugger;
      this.trigger = trigger;
      if (this.player) {
        this.player.record().start();
      }
    },
    handleGenerateClick(){
      this.$emit("generate-click", this.input)
    },
    handleSaveRecording(blob) {
      debugger;
      let test= this.player.record().saveAs({'video': 'glance.mp4'})

      this.videoInfo._created_at = Date.now();
      this.videoInfo.trigger= this.trigger;

      let file = new File([blob], 'glance.mp4');
      

      let prefix= 'glance';
      let fileName = this.createFileName(prefix);

      var storageRef = firebase
          .storage()
          .ref(`${this.storagePath}/${fileName}`);


      this.uploadVideoToStorage(file, storageRef)
          .then(({url, storage})=>{
            this.videoInfo.videoURL = url;
            this.videoInfo.mimeType = this.mimeType;
            this.videoInfo.fileName = fileName;
            this.videoInfo.storage = `gs://heartbeatfamdev.appspot.com/${storage}`;
            this.isEmittedForSave = true;
            this.$emit('video-recorded-info', this.videoInfo);

            //Video uploaded Notification
            this.$store.dispatch("user/showNotification", {
              title: "Clip Saved",
              description: "15 minute clip saved",
              variant: "success"
            });

          }).catch((e)=>{
        console.log(e);
      });
    },
    createFileName(prefix) {
      let result = "";
      var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 15; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
      }
      const timeStamp = new Date().valueOf();

      return `${prefix}_${result}_${timeStamp}`;
    },
    getStorageReference(storagePath, fileName) {
      let result = "";
      var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 15; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
      }
      const timeStamp = new Date().valueOf();

      var storageRef = firebase
          .storage()
          .ref(`${storagePath}/${fileName}_${result}_${timeStamp}`);
      return storageRef;
    },
    uploadVideoToStorage(blob, storageRef) {
      return new Promise((res, rej) => {
        var metadata = {
          contentType: this.mimeType
        };
        var uploadTask = storageRef.put(blob, metadata);
        uploadTask.on(
            "state_changed",
            snapshot => {
              var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log(`Upload is ${progress}% done`);
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  //console.log("Upload is paused");
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  //console.log("Upload is running");
                  break;
              }
            },
            error => {
              rej(error);
            },
            () => {
              uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(downloadURL => {
                    // Get the Storage URI
                    const storageURI = uploadTask.snapshot.ref.fullPath;

                    // You can now use both downloadURL and storageURI
                    res({ url: downloadURL, storage: storageURI });
                  })
                  .catch(error => {
                    rej(error);
                    //console.log("Error uploading video: ", error);
                  });
            }
        );
      });
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  data() {
    return {
      testRecordButtons:[
        {
          type:'Manual',
          recordLength:10
        },
        {
          type:'Medication',
          recordLength:10
        },
        {
          type:'Report',
          recordLength:10
        },
      ],
      player: '',
      mimeType:'video/webm',
      trigger: null,
      storagePath: 'app_glance_videos',
      options: {
        controls: false,
        autoplay: true,
        fluid: true,
        loop: false,
        width: 320,
        height: 240,
        bigPlayButton: false,
        controlBar: {
          volumePanel: false
        },
        plugins: {
          /*
          // this section is only needed when recording audio-only
          wavesurfer: {
              backend: 'WebAudio',
              waveColor: '#36393b',
              progressColor: 'black',
              debug: true,
              cursorWidth: 1,
              displayMilliseconds: true,
              hideScrollbar: true,
              plugins: [
                  // enable microphone plugin
                  WaveSurfer.microphone.create({
                      bufferSize: 4096,
                      numberOfInputChannels: 1,
                      numberOfOutputChannels: 1,
                      constraints: {
                          video: false,
                          audio: true
                      }
                  })
              ]
          },
          */
          // configure videojs-record plugin
          record: {
            audio: true,
            video: true,
            maxLength: this.recordLength,
            displayMilliseconds: true,
            debug: true,
             /* convertEngine: 'ffmpeg.wasm', // enable ffmpeg.wasm plugin
            coreURL: '/node_modules/@ffmpeg/core-mt/dist/umd/ffmpeg-core.js', // multi-threaded worker
            convertWorkerURL: '/node_modules/@ffmpeg/core-mt/dist/umd/ffmpeg-core.worker.js',
            audioWebAssemblyURL: '/node_modules/@ffmpeg/core-mt/dist/umd/ffmpeg-core.wasm', 
            convertOptions: ['-c:v', 'libx264', '-preset', 'slow', '-crf', '22', '-c:a', 'copy', '-f', 'mp4'], // convert recorded data to MP4 (and copy over audio data without encoding)
            pluginLibraryOptions: {
              outputType: 'video/mp4'
            },*/
          }
        }
      },
      videoInfo:{  //Collected by PonyEngine- maybe can be used in places
        _created_at: null,
        videoURL: null,
        trigger: null,
        fileName: null,
        record_count: 0
      },
      motionContext: null
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
